/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const selectOrganisationInputDataSchema = z.object({
	pendingAuthenticationToken: z.string(),
	organisationId: z.string(),
})

export type SelectOrganisationInputDataSchema = z.infer<typeof selectOrganisationInputDataSchema>
